import { render, staticRenderFns } from "./orderStatistics.vue?vue&type=template&id=f194f4b6&scoped=true"
import script from "./orderStatistics.vue?vue&type=script&lang=js"
export * from "./orderStatistics.vue?vue&type=script&lang=js"
import style0 from "./orderStatistics.vue?vue&type=style&index=0&id=f194f4b6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f194f4b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f194f4b6')) {
      api.createRecord('f194f4b6', component.options)
    } else {
      api.reload('f194f4b6', component.options)
    }
    module.hot.accept("./orderStatistics.vue?vue&type=template&id=f194f4b6&scoped=true", function () {
      api.rerender('f194f4b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/orderStatistics/orderStatistics.vue"
export default component.exports